import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const PrintOrdersPage = () => import('./pages/PrintOrdersPage.vue');
const PrinterSettingsPage = () => import('./pages/PrinterSettingsPage.vue');
const DownloadAppPage = () => import('./pages/DownloadAppPage.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.VIPER_PRINTER,
  permissions: ['administrator'],
};

const viperPrinterRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/viper-printer/orders'),
      component: PrintOrdersPage,
      name: 'viper_printer_orders',
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/viper-printer/settings'),
      component: PrinterSettingsPage,
      name: 'viper_printer_settings',
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/viper-printer/download'),
      component: DownloadAppPage,
      name: 'viper_printer_download',
      meta,
    },
  ],
};

export default viperPrinterRoutes;
